import React from 'react';

/**
 * BlogSection - Publicly Owned Power & Large Load Data
 * Exact content from original index.html
 */
function BlogSection() {
  return (
    <section id="blog" className="bg-light">
      <div className="container">

        <div className="row align-items-center mb-5">
          <div className="col-md-6 order-md-2 wow fadeInRight">
            {/* Blog Content */}
            <div className="blog-text">
              <h6 className="third-color mb-3">Municipal Utility Partners</h6>
              <h2>Publicly Owned Power</h2>
              <p>We connect community-first utilities with flexible infrastructure solutions that strengthen grid reliability while preserving local control. Our partnership framework delivers operational flexibility without capital risk, enabling municipal power providers to maximize existing assets and meet evolving grid requirements.</p>
              <a href="#team" className="btn btn-large btn-gradient btn-rounded mt-4">
                Public Benefits
              </a>
            </div>
          </div>
          <div className="col-md-6">
            {/* Blog Image */}
            <div className="blog-image wow hover-effect fadeInLeft">
              <img src="images/blog-image1.jpg" alt="image" />
            </div>
          </div>
        </div>

        <div className="row align-items-center">
          <div className="col-md-6 wow fadeInLeft">
            {/* Blog Content */}
            <div className="blog-text">
              <h6 className="third-color mb-3">Datacenter Operators</h6>
              <h2>Large Load Data</h2>
              <p>We structure partnerships between proven datacenter operators and public power providers, creating deployment opportunities where both parties benefit. Our framework navigates utility requirements and establishes clear terms for large-scale compute infrastructure aligned with grid operations.</p>
              <a href="#about" className="btn btn-large btn-gradient btn-rounded mt-4">
                Strategic Partners
              </a>
            </div>
          </div>
          <div className="col-md-6">
            {/* Blog Image */}
            <div className="blog-image text-end hover-effect wow fadeInRight">
              <img src="images/blog-image2.jpg" alt="image" />
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default BlogSection;